import { withRedirectUnauthorized } from '../../feature/authority/utils/withAuthority'
import SettingsMatch from '../../components/settings/SettingsMatch'

const SettingsMatchPage = () => {
  return <SettingsMatch />;
}

export default withRedirectUnauthorized('popup', SettingsMatchPage);